import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const dashboardRequest = createRequest(constants.dashboard);
export const dashboardSuccess = createSuccess(constants.dashboard);
export const dashboardFailure = createFailure(constants.dashboard);

export const requestDashboard = dashboardRequest;
